<template>
	<div class="on_sale_table">
		<div class="table" >
			<el-table ref="multipleTable" :height="590" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" prop="number" label="员工编号" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="company" label="所属公司" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="name"  label="姓名" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="job"  label="职务" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="micro_number"  label="联系方式" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="email"  label="邮箱" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" label="名片样式">
					<template slot-scope="scope">
						<span>{{getType(scope.row)}}</span>
					</template>
					<template slot="header" slot-scope="scope">
						<el-dropdown @command="selectType">
						  <span class="el-dropdown-link">
						    下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
						  </span>
						  <el-dropdown-menu slot="dropdown">
						    <el-dropdown-item :command="item" v-for="(item,index) in typeList">{{item.style_name}}</el-dropdown-item>
						  </el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="address" label=""  width="100">
					<template slot-scope="scope">
						<img @click="delItem(scope.row)" style="cursor: pointer;width: 16px;height: 16px;" src="../../assets/itemStore/shangchu@2x.png" />
					</template>
				</el-table-column>
			</el-table>
		</div>
		<footer class="d-flex a-center">
			<div class="d-flex a-center">
				<div @click="batchDelshelves(1)" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					批量删除</div>
			</div>
			<div class="d-flex a-center" style="margin-left: 50px;">
				<div @click="batchDelshelves(2)" style="color: #1E69FF;cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #1E69FF;border-radius: 0.625rem;">
					批量录入</div>
			</div>
			<el-pagination style="margin-left: auto;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>
</template>

<script>
	export default {
		props:{
			keyword: {
                type: String,
                default: null
            }
		},
		data(){
			return {
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
				goods_ids : [],
				status : '',
				goods_id : '',
				typeList:[]
			}
		},
		methods: {
			getType(row){
				let str = ''
				this.typeList.forEach((item)=>{
					if(item.id == row.card_style_id){
						str = item.style_name
					}
				})
				return str
			},
			//获取模板列表
			get_card_style_type(){
				
				let aprams = {
					act : 'get_card_style_type',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				
				this.$api.get_card_style_type(aprams).then((res)=>{
					if(res.code == 0){
						this.typeList = res.data
					}
				})
			},
			selectType(row){
				this.tableData.forEach((item)=>{
					item.card_style_id = row.id
				})
			},
			delItem(row){
				this.goods_ids = [row.id]
				this.delGoods()
			},
			getOnsalegoods(){
				let param = {
					act : 'batch_import_card_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					status : 1,
					keyword : this.keyword,
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.batch_import_card_list(param).then((res)=>{
					this.tableData = []
					if(res.code == 0){
						res.data.forEach((item) => {
							this.tableData.push({...item,is_confirm:item.status==1?true:false})
						})
						this.total_records = parseInt(res.total_records)
					}
				})
			},
			onoffGoods(status){
				let param = {
					act : status,
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getOnsalegoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			delGoods(){
				let param = {
					act : 'batch_import_card_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.batch_import_card_del(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getOnsalegoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			batch_import_card_insert(){
				let param = {
					act : 'batch_import_card_insert',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					ids : this.goods_ids.join(',')
				}
				this.$api.batch_import_card_insert(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getOnsalegoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			switchChange(item){
				if(item.is_confirm == false){
					let status = 'enterprise_goods_off'
					this.goods_ids.push(item.id)
					this.onoffGoods(status)
				}else{
					let status = 'enterprise_goods_show'
					this.goods_ids.push(item.id)
					this.onoffGoods(status)
				}
			},
			batchOffshelves(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个商品')
				}else{
					let status = 'enterprise_goods_off'
					this.onoffGoods(status)
				}
			},
			batchDelshelves(status){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个数据')
				}else{
					this.$msgbox.confirm('是否确认此操作?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						if(status == 1){
							this.delGoods()
						}else{
							this.batch_import_card_insert()
						}
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});  
					})
				}
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOnsalegoods()
			},
			handleSelectionChange(val) {
				let goodsId = []
				val.forEach((item) => {
					goodsId.push(item.id)
				})
				this.goods_ids = goodsId
			},
			handleEdit(index, row) {
				row.editStatus = false
				row.editState = 0
				this.$router.push({path:'edit_item',query:row})
			},
			handleDelete(index, row){
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.goods_ids.push(row.id)
					this.delGoods()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})
			},
			openDetail(index, row){
				row.editStatus = true
				row.editState = 1
				this.$router.push({path:'edit_item',query:row})
			},
			filterTag(value, row) {
				console.log(row);
				console.log(value);
				return row.tag === value;
			},
		},
		mounted() {
			this.getOnsalegoods()
			this.get_card_style_type()
			this.$nextTick(function() {
				this.$on('childmethods',function(){
					let param = {
						act : 'batch_import_card_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						status : 1,
						keyword : this.keyword,
						page : this.currentPage,
						size : this.pageSize
					}
					this.$api.login(param).then((res)=>{
						this.tableData = []
						if(res.code == 0){
							res.data.forEach((item) => {
								this.tableData.push({...item,is_confirm:item.status==1?true:false})
							})
							this.total_records = parseInt(res.total_records)
						}
					})
				});
			});
		}
	}
</script>

<style lang="scss" scoped>
	.suojin{
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.on_sale_table{
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}		
		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1.25rem;
			box-sizing: border-box;
		}
	}
</style>
